import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=25b65084&"
import script from "./js/goods_edit.js?vue&type=script&lang=js&"
export * from "./js/goods_edit.js?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports